// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1mtE0","inner":"Footer_inner__-yLfN","nextIcon":"Footer_nextIcon__DHt21","innerLeft":"Footer_innerLeft__U1drV"};